<template>
  <div
    v-if="$store.getters.isLoggedIn"
    id="admin-page"
    class="page">
    <!-- Drawer -->
    <v-navigation-drawer
      v-model="isDrawerOpen"
      :width="drawerWidth"
      mobile-break-point="1024"
      floating
      app>
      <div class="page-logo-container mx-auto my-5">
        <PosmLogo />
      </div>

      <div class="page-navigation-container d-flex flex-column flex-grow-1">
        <TransactionHistorySearchForm
          v-if="adminTabs === '/admin/history'"
        />
      </div>

      <!-- User Account Menu -->
      <UserMenu class="mt-auto" />
      <!-- User Account Menu -->
    </v-navigation-drawer>
    <!-- / Drawer -->

    <!-- Admin Page Content -->
    <v-content>
      <v-toolbar class="flex-column pa-2" style="height: auto; min-height: 80px;">
         <div class="d-flex flex-wrap align-center mt-5 w-100">
            <v-app-bar-nav-icon
              class="page-drawer-toggle mr-0"
              @click="isDrawerOpen = !isDrawerOpen">
            </v-app-bar-nav-icon>

            <v-toolbar-title
              class="pl-0">
              <MainNavigationMenu />
            </v-toolbar-title>
          </div>
      </v-toolbar>

      <!-- Admin Tabs -->
      <div
        id="admin-tabs"
        class="mx-5">
        <v-tabs
          :show-arrows="false"
          v-model="adminTabs">
          <!-- Types -->
          <v-tab
            to="/admin/types"
            v-if="isPermittedAtLeastOne([
              'CallStatusCreate',
              'CallTypesCreate',
              'CustomerTypesCreate',
              'EmployeeTitlesCreate',
              'SoftwareTypesCreate',
              'PurchasingVendorsCreate',
            ])"
            exact>
            Types
          </v-tab>
          <!-- / Types -->

          <!-- Transaction History -->
          <v-tab
            to="/admin/history"
            v-if="isPermittedAll([
              'HistoryGetAll',
            ])"
            exact>
            Transaction History
          </v-tab>
          <!-- / Transaction History -->
        </v-tabs>
      </div>
      <!-- / Admin Tabs -->

      <!-- Types Content -->
      <AdminTypesTables
        v-if="adminTabs === '/admin/types'"
        class="page-content mx-5 mt-5"
      />
      <!-- / Types Content -->

      <!-- History Content -->
      <TransactionHistoryTable
        v-if="adminTabs === '/admin/history'"
        class="page-content mx-5 my-5"
      />
      <!-- / History Content -->
    </v-content>
    <!-- / Admin Page Content -->
  </div>
</template>

<script>
import PosmLogo from '../components/PosmLogo.vue';
import MainNavigationMenu from '../components/MainNavigationMenu.vue';
import UserMenu from '../components/UserMenu.vue';
import AdminTypesTables from '../components/AdminTypesTables.vue';
import TransactionHistoryTable from '../components/TransactionHistoryTable.vue';
import TransactionHistorySearchForm from '../components/TransactionHistorySearchForm.vue';

export default {
  name: 'StubPage',
  components: {
    PosmLogo,
    MainNavigationMenu,
    UserMenu,
    AdminTypesTables,
    TransactionHistoryTable,
    TransactionHistorySearchForm,
  },
  data() {
    return {
      adminTabs: '/admin/types',
    };
  },
};
</script>

<style lang="scss"></style>
